import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as ActivoFijoService from 'services/activosFijos.service'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  { name: 'Activos Fijos', path: `/${CodigosTransaccionesConstant.ACTIVOSFIJOS_LISTA}` },
  { name: 'Nuevo' }
]

const EditarPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)
  const [editData, setEditData] = React.useState(null)

  React.useEffect(() => {
    ActivoFijoService.get(match.params.idActivoFijo)
      .then(({ data }) => {
        setEditData(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, match.params.idActivoFijo])

  return (
    <>
      {editData && (
        <Portlet>
          <Portlet.Header title='Activos Fijos' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            <MainForm editData={editData} />
          </Portlet.Body>
        </Portlet>
      )}
    </>
  )
}

export default React.memo(EditarPage)
